import logo from '../assets/LogoApp.png';

export const LogoApp = ({ className, onClick }: { className?: string; onClick?: () => void }) => {
  return <img src={logo} className={className} onClick={onClick} alt="logo app" />;
};
